import { render, staticRenderFns } from "./PointReward.vue?vue&type=template&id=4f09db0d&scoped=true&"
import script from "./PointReward.vue?vue&type=script&lang=js&"
export * from "./PointReward.vue?vue&type=script&lang=js&"
import style0 from "./PointReward.vue?vue&type=style&index=0&id=4f09db0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f09db0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f09db0d')) {
      api.createRecord('4f09db0d', component.options)
    } else {
      api.reload('4f09db0d', component.options)
    }
    module.hot.accept("./PointReward.vue?vue&type=template&id=4f09db0d&scoped=true&", function () {
      api.rerender('4f09db0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/campaign/components/PointReward.vue"
export default component.exports